import React, { PureComponent } from 'react';
import { AppState, AppStateStatic, AppStateStatus } from 'react-native';

export interface IAppStateFocusedEventsProps {
  navigation?: any;
  enableBackgroundFocusEvent?: boolean;
  onScreenFocus(): void;
  onScreenUnfocus?(): void;
}

interface IAppStateFocusedEventsState {
  appState: AppStateStatus;
}

export class AppStateFocusedEvents extends PureComponent<IAppStateFocusedEventsProps, IAppStateFocusedEventsState> {
  private onFocusListener: any;
  private onBlurListener: any;

  constructor(props) {
    super(props);
    this.state = {
      appState: AppState.currentState,
    };
  }
  public componentDidMount() {
    const { enableBackgroundFocusEvent = true } = this.props;
    if (enableBackgroundFocusEvent) {
      AppState.addEventListener('change', this.handleAppStateChange);
    }
    if (this.props.navigation) {
      this.onFocusListener = this.props.navigation.addListener('didFocus', () => {
        this.focusEvent();
      });
      this.onBlurListener = this.props.navigation.addListener('didBlur', () => {
        this.unFocusEvent();
      });
    }
  }

  public componentWillUnmount() {
    const { enableBackgroundFocusEvent = true } = this.props;
    if (enableBackgroundFocusEvent) {
      AppState.removeEventListener('change', this.handleAppStateChange);
    }
    this.unFocusEvent();
    if (this.onFocusListener) {
      this.onFocusListener.remove();
    }
    if (this.onBlurListener) {
      this.onBlurListener.remove();
    }
  }

  public handleAppStateChange = (nextAppState: AppStateStatus) => {
    if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
      this.focusEvent();
    } else {
      this.unFocusEvent();
    }
    this.setState({ appState: nextAppState });
  }

  public focusEvent = () => {
    const { onScreenFocus } = this.props;
    if (!onScreenFocus) {
      throw new Error('onScreenFocus() is not defined');
    }
    onScreenFocus();
  }

  public unFocusEvent = () => {
    const { onScreenUnfocus } = this.props;
    if (onScreenUnfocus) {
      onScreenUnfocus();
    }
  }

  public render() {
    return null;
  }
}
